










import { Component, Vue } from "vue-property-decorator";
import { ComponentOptions, AsyncComponent } from "vue";

export type TComponent = ComponentOptions<Vue> | typeof Vue | AsyncComponent;

@Component({})
export default class Logout extends Vue {
  get settingComponents(): TComponent[] {
    if (this.$route.meta) return this.$route.meta.settingComponents || [];
    return [];
  }
}
